import { Component, Injectable, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { YoyakuService } from '../service/yoyaku.service';

@Injectable()
export class I18n {
  language = "ja";
}

@Component({
  selector: "yoyaku-confirm-add-app",
  templateUrl: "./yoyaku-confirm-add.component.html",
  styleUrls: ["yoyaku-confirm-add.component.css"],
})
export class YoyakuConfirmAddComponent implements OnInit {
  @Input() inputContent: any;
  @Input() yoyakuData: any;
  @Input() yoyakuId: any;

  constructor(
    private commonService: CommonService,
    private yoyakuService: YoyakuService,
  ) {}

  contentList: any = [];
  contentIsShow: boolean = false;

  ngOnInit(): void { 
    let a = this.yoyakuData;
    this.getYoyakuCustomize38();
  }

  getYoyakuCustomize38(): void {
    this.yoyakuService.getCustomize38(this.yoyakuData.m_yoyakuhyo_id, this.yoyakuId)
      .subscribe((res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.contentList = res["fuel_results"];
          for(let i=0; this.contentList.length>i; i++){
            this.contentList[i].input = null;
            if(this.contentList[i].exists_answer_name != null){
              this.contentList[i].input = this.contentList[i].exists_answer_id;
            }
            if(this.contentList[i].exists_answer_name_2 != null){
              this.contentList[i].input = this.contentList[i].exists_answer_id_2;
            }
          }
          this.onChange(null);
          this.onChange("3");
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
        }else{
            this.commonService.modalOpens(11003,modalresult=>{});
        }
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }

  onChange(id:string): void{
    if(id=="3"){
      let temp = this.contentList.filter(
        (v) => v.m_question_kbn_id == "3"
      );
      if(temp[0].input==2 || temp[0].input==3){
        this.contentIsShow = true;
      }else{
        this.contentIsShow = false;
        for(let i=0; this.contentList.length>i; i++){
          if(this.contentList[i].m_question_kbn_id=="4"){
            this.contentList[i].input = null;
          }
        }
      }
    }
    let param = [];
    for(let i=0; this.contentList.length>i; i++){
      let tmpArray = {m_question_kbn_id: null, m_question_param: null};
      tmpArray.m_question_kbn_id = this.contentList[i].m_question_kbn_id;
      tmpArray.m_question_param = this.contentList[i].input;
      param[i] = tmpArray;
    }
    this.inputContent.inputParam = param;
  }
}



// WEBPACK FOOTER //
// ./src/app/g3802-yoyaku-confirm-add/yoyaku-confirm-add.component.ts